import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, getDocs, doc, setDoc } from 'firebase/firestore';

function InitializePins() {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const initializePins = async () => {
    setLoading(true);
    setStatus('Starting initialization...');
    setResults([]);

    try {
      // Get all students
      const studentsSnapshot = await getDocs(collection(db, 'students'));
      setStatus(`Found ${studentsSnapshot.size} students. Creating PINs...`);

      let successCount = 0;
      let errorCount = 0;
      const logs = [];

      for (const studentDoc of studentsSnapshot.docs) {
        const rollNumber = studentDoc.id;
        const studentData = studentDoc.data();

        try {
          // Create secupin document
          await setDoc(doc(db, 'secupin', rollNumber), {
            pin: '123456',
            isDefault: true,
            createdAt: new Date(),
            changedAt: null,
            rollNumber: rollNumber,
            studentName: `${studentData.firstName || ''} ${studentData.surname || ''}`.trim()
          });

          successCount++;
          logs.push(`✅ ${rollNumber} - ${studentData.firstName} ${studentData.surname}`);
        } catch (error) {
          errorCount++;
          logs.push(`❌ ${rollNumber} - Error: ${error.message}`);
        }
      }

      setResults(logs);
      setStatus(`✅ Done! Success: ${successCount}, Errors: ${errorCount}`);
    } catch (error) {
      setStatus(`❌ Error: ${error.message}`);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            🔐 Initialize Security PINs
          </h1>
          <p className="text-gray-600 mb-6">
            This will create default PIN (123456) for all students in the database.
          </p>

          <button
            onClick={initializePins}
            disabled={loading}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? 'Initializing...' : 'Initialize All PINs'}
          </button>

          {status && (
            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-blue-800 font-medium">{status}</p>
            </div>
          )}

          {results.length > 0 && (
            <div className="mt-6">
              <h2 className="text-xl font-bold mb-4">Results:</h2>
              <div className="bg-gray-50 rounded-lg p-4 max-h-96 overflow-y-auto">
                {results.map((log, index) => (
                  <p key={index} className="text-sm font-mono mb-1">
                    {log}
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default InitializePins;
